import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.BRANCHES_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.BRANCHES_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.BRANCHES_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.BRANCHES_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.BRANCHES_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.BRANCHES_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
};
